var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6v27a9 9 0 0 0 9 9h30a9 9 0 0 0 9-9V6H0Zm46 27a7 7 0 0 1-7 7H9a7 7 0 0 1-7-7V8h44v25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.48 13.67-1.34-1.48L24 27.65 6.96 12.21l-1.34 1.48L24 30.35l18.48-16.68z"
  })));
};
export default SvgMail;